var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:phone-bold-duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.15 20.0385L24.834 19.359C25.779 18.42 27.2505 18.2265 28.4595 18.8835L31.3245 20.442C33.165 21.4425 33.5715 23.895 32.133 25.3245L30.003 27.4425C29.46 27.9825 28.788 28.3755 28.014 28.4475C26.226 28.614 22.5465 28.524 18.2055 25.983L24.15 20.0385ZM15.285 11.2245L15.7155 10.7955C16.776 9.74253 16.8765 8.05053 15.951 6.81453L14.061 4.29003C12.915 2.76003 10.7025 2.55753 9.39 3.86253L7.035 6.20253C6.3855 6.85053 5.9505 7.68753 6.003 8.61753C6.1005 10.3275 6.6825 13.4475 9.2265 17.2815L15.285 11.2245Z",
    fill: "#0066ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.6,
    d: "M18.0945 17.2455C13.6755 12.852 15.2745 11.2335 15.285 11.223L9.2265 17.283C10.227 18.789 11.529 20.4045 13.2225 22.089C14.9325 23.79 16.6125 25.0515 18.2055 25.983L24.15 20.04C24.15 20.04 22.527 21.654 18.0945 17.247",
    fill: "#0066ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1f4f35ee00e620be2a5e4af62c17a562.svg";
export { ForwardRef as ReactComponent };